module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/toc#ch2"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE YOUNG WOMAN’S DEATH")]), _vm._v(" did not find its way into Jarvis Stringer’s book.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Only accidents of a more spectacular kind would appear there, the first “sledger” to come to grief, the over-zealous railmen attempting to close doors who were decapitated at tunnel portals, the victims of fire. He read the account of the inquest and of the later failed efforts of the family to bring an action against London Transport Underground. If they had been successful, the incident might have appeared in one of the chapters of disaster.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The girl’s brother was later to claim acquaintance with him but by that time Jarvis was in Russia and his book half-finished. He started it while he was living with his mother in Wimbledon, before he moved to the School.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was to be a complete history of the London Underground.")]), _vm._v(" "), _c('p', {
    staticClass: "ttx1"
  }, [_c('i', [_vm._v("London has the world’s oldest metro system [he began]. It dates back to 1863, to a Victorian London of slums, of gaslight, of the powerless and the poor. Three-quarters of a million people came there every day to work. They came on foot, by river steamer and in horse-drawn omnibuses and drays. And there were those who could not come at all, they lived too far away.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("One man had a vision of a railway that would link all the mainline railway termini. His name was Charles Pearson and, though born the son of an upholsterer, he became Solicitor to the City of London,")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("“A poor man,” he wrote, “is chained to the spot. He has not leisure to walk and he has not money to ride a distance to his work.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("There had previously been a plan for gaslit subway streets through which horse-drawn traffic could pass. This was rejected on the grounds that such sinister tunnels would become lurking places for thieves. Twenty years before his railway was built, Pearson envisaged a line running through “a spacious archway,” well-lit and well-ventilated.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("His was a scheme for trains in a drain.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0433c1eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch2.vue
// module id = 87
// module chunks = 0